import React from 'react';
import { Checkbox } from 'antd';
import classnames from 'classnames';
import { wowRoot } from '@liepin/js-core4c-fe';
import styled from './index._less';
import { ELoginType } from '../../enum';
import useLogin from '../../hooks/use-login';


export default () => {

  const { loginType, checkedAgreement, changeCheckedAgreement, isModal } = useLogin();

  return (
    <>
      {
        loginType === ELoginType.Login ||
        loginType === ELoginType.Reg
        ? <div
            className={ classnames('login-agreement', { 'login-agreement-modal': isModal, 'login-agreement-component': !isModal, }) }
          >
            <div>
              <Checkbox
                checked={ checkedAgreement }
                onChange={ e => changeCheckedAgreement(e.target.checked) }
              ><span className="login-agreement-text">同意猎聘</span></Checkbox>
              <a target="_blank" href={ `${wowRoot}/t1005005/7dfc3910.html` }>《猎聘用户服务协议》</a>
              <span>及</span>
              <a target="_blank" href={ `${wowRoot}/t1005001/0996fc1c.html` }>《个人信息保护政策》</a>
            </div>
          </div>
        : ''
      }
      <style jsx>{ styled }</style>
    </>
  )
}
